import { graphql } from '@/lib/query'

const SectionPrivacyFragment = graphql(
  /* GraphQL */ `
    fragment SectionPrivacyFragment on SectionPrivacyRecord @_unmask {
      id
      __typename
      _modelApiKey
    }
  `,
  []
)

export default SectionPrivacyFragment
